import React from 'react';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import { useMutation } from 'react-query';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

import * as Api from '../api';
import * as Types from '../types';

interface IFormValues extends Types.IForm.ChangeActualPhone {}

interface IChildren extends FormikProps<IFormValues> {}

interface IProps {
  registerId: number;
  className?: string;
  onSuccess?: (data: any) => void;
  onError?: (error: string) => void;
  onSettled?: () => void;
  children(props: IChildren): JSX.Element;
}

const ChangePhone: React.FC<IProps> = ({ registerId, onSuccess, onError, onSettled, children }) => {
  const { t } = useTranslation();

  const mutation = useMutation<any, string, IFormValues, any>(
    async values => {
      const { data } = await Api.ChangeActualPhone({ values });

      return data && data.data;
    },
    {
      onSuccess,
      onError,
      onSettled
    }
  );

  const validationSchema = yup.object().shape<IFormValues>({
    registerId: yup.number().required(),
    phone: yup.string().min(9, t('phone_number_is_invalid')).required(t('phone_is_a_required_field'))
  });

  const handleSubmit = (values: IFormValues, { setSubmitting }: FormikHelpers<IFormValues>) => {
    setSubmitting(true);
    mutation.mutate(values, {
      onSettled: () => setSubmitting(false)
    });
  };

  return (
    <Formik<IFormValues>
      onSubmit={handleSubmit}
      initialValues={{
        registerId,
        phone: ''
      }}
      {...{ validationSchema }}
    >
      {(props: FormikProps<IFormValues>) => <Form>{children(props)}</Form>}
    </Formik>
  );
};

export default ChangePhone;
